<template>
  <div class="location">
    <v-icon class="home">mdi-home-outline</v-icon>
    <v-icon class="arrow-1">mdi-chevron-right</v-icon>
    <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
      <template slot="item" slot-scope="props">
        <router-link :to="{ name: props.item.href }" class="link">{{
          props.item.name
        }}</router-link>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
    };
  },

  watch: {
    $route() {
      const vm = this;

      vm.updateBreadcrumbs();
    },
  },

  mounted() {
    const vm = this;

    vm.updateBreadcrumbs();
  },

  methods: {
    updateBreadcrumbs() {
      const vm = this;

      vm.items = vm.$route.meta.breadcrumb;
    },
  },
};
</script>

<style lang="scss" scoped>
.location {
  display: flex;
  align-items: center;
  line-height: 1.2;
  .v-breadcrumbs {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .arrow-1 {
    color: #ddd;
    margin: 0 6px;
    font-size: 16px;
  }
  .v-breadcrumbs li .v-icon {
    margin: 0 -4px;
    color: #ddd;
  }
  a {
    color: #999;
    font-size: 12px;
  }
}
</style>
